'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/5/20.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _VerificationCodeInput = require('../GoeasyInputField/VerificationCodeInput');

var _VerificationCodeInput2 = _interopRequireDefault(_VerificationCodeInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalForgetPassword = (_dec = (0, _reduxForm.reduxForm)({
  form: 'forgetPassword',
  fields: ['verifyCode']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalForgetPassword, _Component);

  function PersonalForgetPassword() {
    (0, _classCallCheck3.default)(this, PersonalForgetPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalForgetPassword).call(this));

    _this.state = {
      verifyClick: false,
      waitingTime: 60
    };
    return _this;
  }

  (0, _createClass3.default)(PersonalForgetPassword, [{
    key: 'render',
    value: function render() {
      var styles = require('./PersonalInfoChange.scss');
      var _props = this.props;
      var verifyCode = _props.fields.verifyCode;
      var handleSubmit = _props.handleSubmit;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.component },
          _react2.default.createElement(_VerificationCodeInput2.default, { label: '认证：' }),
          _react2.default.createElement(_GoeasyInputField2.default, { inputPlaceholder: '请输入验证码', formProps: verifyCode }),
          _react2.default.createElement('input', { className: styles.btn, type: 'button', onClick: handleSubmit, value: '确定' })
        )
      );
    }
  }]);
  return PersonalForgetPassword;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PersonalForgetPassword;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalInfoChange/PersonalForgetPassword.js
 ** module id = 1399
 ** module chunks = 0
 **/